// extracted by mini-css-extract-plugin
export default {"loading_container":"styles_loading_container__+cmjv","loading_spinne":"styles_loading_spinne__2oLh2","spin":"styles_spin__BSZXD"};